






import { Component, Prop, Vue, Emit } from 'vue-property-decorator'
import { Payee } from '@/services/models'
import { Action, Getter } from 'vuex-class'

@Component
export default class CustomerSelector extends Vue {

  @Prop({
    default: '',
  })
  private value!: string|null

  @Getter('firestore/payees')
  private payees!: Payee[]

  @Action('firestore/fetchPayees')
  private fetchPayees!: () => Promise<any>

  private get options(): Array<{ value: string, text: string }> {
    return this.payees && this.payees.map((c) => ({
      value: c.code,
      text: c.name,
    }))
  }

  public mounted() {
    this.fetchPayees()
  }

  @Emit()
  public input(payeeId: string) {
    // pass
    const o = this.payees.find((c) => c.code === payeeId)
    this.selected(o)
  }

  @Emit('selected')
  public selected(customer?: Payee) {
    // pass
  }
}
